import * as Eq from "fp-ts/es6/Eq"

export type ActivitySettingsSleep = Record<string, unknown>
export const activitySettingsSleep: Eq.Eq<ActivitySettingsSleep> = Eq.struct({})
export const empty: ActivitySettingsSleep = {}
